import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import IDInput from './IDInput';
import { useHistory } from "react-router-dom";
import axios from 'axios';
const Update = (props) => {
    const [showHelp, setShowHelp] = useState(false);
    const [recallID, setRecallID] = useState('');
    const [showError, setShowError] = useState(false);
    const [foundID, setFoundID] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    let history = useHistory();

    const handleShowHelp = (e) => {
        e.preventDefault();     
        setShowHelp(true);
     
    }
    const handleClose = (e) => {
        e.preventDefault();       
            setShowHelp(false);
        
    }
    const handleNext = (e) => {
        e.preventDefault();
        if (recallID == '') {
            setShowError(true);
            setErrorMessage('Please enter a Unique Identifier');
        } else {
            // recall the latest only
            axios.get('api/uniqueresponse/' + recallID, { withCredentials: true }).then(response => {
                sessionStorage.removeItem('uniqueResponse' + recallID); sessionStorage.removeItem('questionResponses' + recallID);
                console.log(response.data.isInternal);
                history.push('/form/' + recallID + '/duc' + (response.data.isInternal ? '?ltc=' : ''));
            }).catch(error => {
                setShowError(true);
                setErrorMessage("Invalid Unique ID, please try again.");
            });

        }
    }
    const onRecallIDChange = (value) => {
        setRecallID(value);
    }
    return ( 
        <div>      
            <Container className="content">
          
            <h2>Update an existing DUC</h2>
                <p>To update a DUC that you have completed previously, enter your unique ID below and click Next to continue.</p>
                <p>The unique ID is the short numerical code displayed on the summary of your previously completed DUC.</p>
                {showError ? <span className="error">{errorMessage}</span> : <span />}
                <IDInput onRecallIDChange={onRecallIDChange} />
                <br /> 
                <div>Can't find your Unique ID? <a href="new/0">Start a new DUC</a>.</div>           
              

                    </Container>

            <div className="page-nav">
                <div><a href="home" className="link-small-back"> Back</a></div>
                <div><a href="#" onClick={handleNext} className="link-small">Next</a></div>
                </div>
     
        </div >
    )
}
export default Update;